import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Card, Col, FormGroup, Label, Row } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import FilterDropdown from "../../../../Components/Common/FilterDropdown";
import { EDIT_LEAD_API, GET_LEAD_LIST_API, GET_LEAD_STATUS_API } from "../../../../helpers/url_helper";
import CommanDataTable from "../../../../Components/Common/DataTable";
import { APIClient } from "../../../../helpers/api_helper";
import moment from "moment/moment";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import { deleteLeads } from "../../../../store/leadManagement/actions";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "../../../../Components/Common/Flatpicker";
import { getPreviousLeadDate, setCurrentDate } from "../../../../Components/Common/DefaultDateSet";
import TeamSelect from "../../../../Components/Common/TeamSelect";
import { CommonLabel } from "../../../../Components/Common/CommonLabel";
import EmployeeSelect from "../../../../Components/Common/EmployeeSelect";
import { MultiSelect } from "react-multi-select-component";
import { CommanSelectModal } from "../../../../Components/Common/CommanSelectModal";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { defaultSelectedOptions, formatFlatPickerDates } from "../../../../Components/Common/ToCamelCase";
import { fetchLeadStatusRequest } from "../../../../store/FetchLeadStatus/action";
import SubExpired from "../../../../Components/Common/subExpired";
import { useProfileData } from "../../../../Components/Hooks/UserHooks";
import CalculateRemainingDays from "../../../../Components/Common/CalculateRemainingDays";
const api = new APIClient();



const LeadManagment = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { statusOptions } = useSelector(state => state.leadStatusReducer);
    // default date 
    const previewsDate = getPreviousLeadDate();
    const currentDate = setCurrentDate();
    const [getLeadStatus, setGetLeadStatus] = useState([]);

    // custom hookes
    const { lead, success } = useSelector((state) => ({
        lead: state.LeadReducer.leads,
        success: state.LeadReducer.success,
    }));

    // date picker state
    const [selectedFromDate, setSelectedFromDate] = useState(previewsDate);
    const [selectedToDate, setSelectedToDate] = useState(currentDate);

    // Memoized formatted dates
    const formattedDates = useMemo(() =>
        formatFlatPickerDates(selectedFromDate, selectedToDate),
        [selectedFromDate, selectedToDate]
    );

    const [selectedEmployeeOptions, setSelectedEmployeeOptions] = useState([]);
    const [selectedEmployeeOptions2, setSelectedEmployeeOptions2] = useState([]);



    const [prevEmployeesIds_Test, setPrevEmployeesIds_Test] = useState([]);
    const [prevstatus_Test, setPrevstatus_Test] = useState([]);


    // fillter state
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedOptions, setSelectedOptions] = useState(defaultSelectedOptions);


    // datatable state 
    const [query, setQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState('');
    const [getListData, setGetListData] = useState([]);
    const [activeColumns, setActiveColumns] = useState([]);
    const [isFirstEffectRun, setIsFirstEffectRun] = useState(false);
    // error message show in not a select empty
    const [error, setError] = useState("");
    const [statusError, setStatusError] = useState("");


    const [teamIndu, setTeamIndu] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);



    // delete state
    const [leadTodo, setLeadTodo] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [EmployeeDefaultWithoutTeam, setEmployeeDefaultWithoutTeam] = useState([]);
    const [EmployeeData, setEmployeeData] = useState([]);


    //  open in modal
    const [checkOpen, setCheckOpen] = useState(false)
    const [allStatusError, setAllStatusError] = useState("")

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [allLeadRemoveId, setAllLeadRemoveId] = useState([])
    const [appliedDateRange, setAppliedDateRange] = useState({
        startDate: formattedDates.formattedStartDate,
        endDate: formattedDates.formattedEndDate,
    });

    const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);
    const { profileData } = useProfileData();
    const remainingDays = CalculateRemainingDays();

    useEffect(() => {
        dispatch(fetchLeadStatusRequest());
    }, [dispatch]);

useEffect(() => {
  if (statusOptions && statusOptions.length > 0) {
    setGetLeadStatus([]);
  }
}, [statusOptions]);
    // table column 
    const columns = [
        {
            name: "SN.",
            selector: (row, index) => index + 1,
            width: "55px",
        },

        {
            name: "First Name",
            selector: (row) => row.firstName,
            cell: (row) => <span>{row.firstName || "-"}</span>,
            sortable: true,
            key: "firstName",
        },

        {
            name: "Last Name",
            selector: (row) => row.lastName,
            cell: (row) => <span>{row.lastName || "-"}</span>,
            sortable: true,
            key: "lastName",
        },

        {
            name: "Contact Number",
            selector: (row) => row.phone,
            cell: (row) => <span>({row?.countryCode}) {row.phone || "N/A"}</span>,
            sortable: true,
            key: "phone",
        },

        {
            name: "Email",
            selector: (row) => row.email,
            cell: (row) => <span>{row.email || "-"}</span>,
            sortable: true,
            key: "email",
        },

        {
            name: "Company Name",
            selector: (row) => row.companyName,
            cell: (row) => <span>{row.companyName || "-"}</span>,
            sortable: true,
            key: "companyName",
        },
        {
            name: "Country",
            selector: (row) => row.country,
            cell: (row) => <span>{row.country || "-"}</span>,
            sortable: true,
            key: "country",
        },
        {
            name: "State",
            selector: (row) => row.state,
            cell: (row) => <span>{row.state || "-"}</span>,
            sortable: true,
            key: "state",
        },
        {
            name: "City",
            selector: (row) => row.city,
            cell: (row) => <span>{row.city || "-"}</span>,
            sortable: true,
            key: "city",
        },

        {
            name: "Created Date",
            selector: (row) => row.createdAt,
            cell: (row) => <span>{moment(row.createdAt).format('DD  MMM  YYYY') || "N/A"}</span>,
            sortable: true,
            key: "createdAt",
        },
        {
            name: "Postal Code",
            selector: (row) => row.pincode,
            cell: (row) => <span>{row.pincode || "-"}</span>,
            sortable: true,
            key: "pincode",
        },

        {
            name: "Source",
            selector: (row) => row.source,
            cell: (row) => <span>{row.source || "-"}</span>,
            sortable: true,
            key: "source",
        },

        {
            name: "Deal Amount",
            selector: (row) => row.dealAmount,
            cell: (row) => <span>{row.dealAmount || "-"}</span>,
            sortable: true,
            key: "dealAmount",
        },
        {
            name: "Lead Status",
            selector: (row) => row.status,
            cell: (row) => <span>{row.status || "-"}</span>,
            sortable: true,
            key: "status",
        },

        {
            name: <span className="font-weight-bold fs-13">Assigned To</span>,
            selector: (row) => row.assignedTo,
            cell: (row) => (
                <div className="mt-2 mb-2">
                    {row?.assignedTo && row.assignedTo.length > 0 ? (
                        row.assignedTo.map((assign, index) => (
                            <React.Fragment key={index}>
                                <span style={{ textTransform: "capitalize", textAlign: "left", float: "left" }}>
                                    {assign?.fullName}
                                </span>
                                <br />
                                {index !== row.assignedTo.length - 1 && <br />}
                            </React.Fragment>
                        ))
                    ) : (
                        <span>-</span>
                    )}
                </div>
            ),
            sortable: true,
            key: "assignedTo",
        },


        {
            name: <span className="font-weight-bold fs-13">Action</span>,
            selector: (row) => (
                <>
                    <span className="sn-role-managment-responsive-btn">
                        <Button onClick={() => onClickLeadDelete(row)}
                            className="btn btn-sm btn-soft-danger remove-list"

                        >
                            <i className="ri-delete-bin-5-fill align-bottom" />
                        </Button>
                        &nbsp;&nbsp;
                        <Button onClick={() => handleLeadClick(row)} className="btn btn-sm btn-soft-success edit-list">
                            <i className="ri-pencil-fill align-bottom" />
                        </Button>
                    </span>
                </>
            ),
        },
    ];


    // State for search term
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };


    // Form Date function 
    const handleFromDateChange = (dates) => {
        setSelectedFromDate(dates[0]);
    };


    // To Date function 
    const handleToDateChange = (dates) => {
        setSelectedToDate(dates[0]);
    };


      useEffect(() => {
        const handler = setTimeout(() => {
          setDebouncedQuery(query);
          setCurrentPage(1);
        }, 500);
     
        return () => {
          clearTimeout(handler);
        };
      }, [query]);

    //edit team function
    const handleLeadClick = (row) => {
        navigate('/edit-Lead', {
            state: {
                leadData: row
            }
        });
    };


    // delete function
    const onClickLeadDelete = (todo) => {
        setLeadTodo({ todo: todo, leadtype: 'singleLeadRemove' });
        setDeleteModal(true);
    };


    // search handle function
    const handleSearch = (e) => {
        setQuery(e.target.value);
    };


    useEffect(() => {
        let dateObj = {
            startDate: formattedDates.formattedStartDate,
            endDate: formattedDates.formattedEndDate,
        }
        if (debouncedQuery.length >= 3 || debouncedQuery.length === 0) {
            fetchLeadList(currentPage, perPage, debouncedQuery, [], [], dateObj);
        }
    }, [currentPage,perPage,debouncedQuery]);

    

    // Lead List Table data Submit data
    const handleApplySubmit = async () => {
        let leadsStatus = getLeadStatus.map((lead) => lead?.value);
        let updatedIds = selectedEmployeeOptions.map((userid) => userid?.id);
        let dateObj = {
            startDate: formattedDates.formattedStartDate,
            endDate: formattedDates.formattedEndDate,
        }
        setAppliedDateRange(dateObj);
        fetchLeadList(currentPage, 10, '', updatedIds, leadsStatus, dateObj);
        setSelectedEmployeeOptions2(selectedEmployeeOptions);
        setCurrentPage(1)
        setPerPage(10);
        setError("");
    };



    // Pagination handler
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // handle per row change
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };


    // All edit formik use in function 
    const {
        handleSubmit,
        setFieldValue,
        getFieldProps,
        resetForm,
    } = useFormik({
        enableReinitialize: true,
        initialValues: {
            leadstatus: '',
            assigned: ''
        },
        validationSchema: Yup.object({
        }),
        onSubmit: async (value) => {
            let dateObj = {
                startDate: formattedDates.formattedStartDate,
                endDate: formattedDates.formattedEndDate,
            }
            let leadsStatus = getLeadStatus.map((lead) => lead?.value);
            let updatedIds = selectedEmployeeOptions2.map((userid) => userid?.id);
            let status = value.leadstatus.length > 0 ? value.leadstatus : undefined
            let assignedTo = value.assigned.length > 0 ? [value.assigned] : undefined;
            const leadeditData = {
                leadIds: allLeadRemoveId,
                ...(status && { status }),
                ...(assignedTo && { assignedTo }),
            };
            try {
                const response = await api.patch(`${EDIT_LEAD_API}`, leadeditData);
                if (response && response.success === true) {
                    toast.success(response.message, { autoClose: 1000 });
                    setIsModalOpen(false)
                    setCheckOpen(false);
                    resetForm();
                    await fetchLeadList(currentPage, perPage, '', updatedIds, leadsStatus, dateObj);
                }

            } catch (error) {
                toast.error(error.response?.data?.message, { autoClose: 1000 });
            }
        },
    });





    // Memoized API request data
    const getRequestData = useCallback((searchTerm = '', updatedIds, leadsStatus, dateObj) => ({
        startDate: dateObj.startDate,
        endDate: dateObj.endDate,
        employeeIds: updatedIds || selectedEmployeeOptions2.map(userid => userid?.id),
        status: leadsStatus || getLeadStatus?.map(lead => lead?.value)
    }), [formattedDates, selectedEmployeeOptions2, getLeadStatus]);



    // Lead list function 
    const fetchLeadList = async (page, size, searchTerm = '', updatedIds, leadsStatus, dateObj) => {
        setIsLoading(true);
        try {
            const requestData = getRequestData(searchTerm, updatedIds, leadsStatus, dateObj);
            const response = await api.create(
                `${GET_LEAD_LIST_API}?pg=${page}&lm=${size}&query=${searchTerm}`,
                requestData
            );
            if (response && response.success === true) {
                const apiResponse = response.data;
                setGetListData(apiResponse.leads)
                setTotalRows(apiResponse?.totalCount);
            }
        } catch (error) {
            console.log(error);

        } finally {
            setIsLoading(false);
        }
    };



    // add and delete 
    useEffect(() => {
        if (success) {
            if (deleteModal) {
                setDeleteModal(false);
            }
            if (isModalOpen) {
                setIsModalOpen(false);
            }
            let leadsStatus = getLeadStatus.map((lead) => lead?.value);
            let updatedIds = selectedEmployeeOptions.map((userid) => userid?.id);
            let dateObj = {
                startDate: formattedDates.formattedStartDate,
                endDate: formattedDates.formattedEndDate,
            }
            // formik.resetForm();
            fetchLeadList(currentPage, perPage, '', updatedIds, leadsStatus, dateObj);
            dispatch({ type: "RESET_SUCCESS_STATE" });
        }
    }, [selectedEmployeeOptions,
        success,
        currentPage,
        perPage,
        deleteModal,
        dispatch,
        fetchLeadList,
    ]);



    useEffect(() => {
        const updatedColumns = columns.filter((col) => (col.key ? selectedOptions.includes(col.key) : true));
        setActiveColumns(updatedColumns);
    }, [selectedOptions]);


    // all select row lead edit and remove
    const handleSelectedRowsChange = () => ({ selectedRows }) => {
        if (selectedRows && selectedRows.length > 0) {
            setCheckOpen(true);
            const lead_id = selectedRows.map((item) => item._id);
            setAllLeadRemoveId(lead_id);
        } else {
            setCheckOpen(false);
            setAllLeadRemoveId([]);
        }
    };



    // delete team function
    const handleDeleteLeadData = useCallback(() => {
        if (leadTodo && leadTodo.leadtype === 'singleLeadRemove') {
            let lead = { leadIds: [leadTodo?.todo?._id] };
            dispatch(deleteLeads(lead));
            setDeleteModal(false);
        }
        else if (leadTodo && leadTodo.leadtype === 'allLeadRemove') {
            let lead = { leadIds: leadTodo?.leadId };
            dispatch(deleteLeads(lead));
            setDeleteModal(false);
        }
    }, [leadTodo, dispatch, setDeleteModal]);


    // filter status select function
    const handleStatusChange = (selectedOptions) => {
        if (selectedOptions) {
            setGetLeadStatus(selectedOptions)
            setStatusError('')
        }
    }

    // All delete lead function
    const onClickAllLeadDelete = () => {
        setLeadTodo({ leadId: allLeadRemoveId, leadtype: 'allLeadRemove' });
        setDeleteModal(true);
    };


    // All edit lead function
    const handleAllEditLeadClick = useCallback((arg) => {
        setIsModalOpen(true);
    }, []);



    // All edit modal function status select 
    const handleAllStatusChange = (event) => {
        const status = event.target.value;
        if (status) {
            setFieldValue("leadstatus", status);
        }
        setAllStatusError('')
    }


    // All edit modal function Assigned select 
    const handleAssignedChange = (e) => {
        const selectedValue = e.target.value;
        if (selectedValue) {
            setFieldValue("assigned", selectedValue);
        }
        setAllStatusError('')
    };


    const toggle = () => {
        setIsModalOpen(!isModalOpen);
        resetForm();
    }

    
    const handleClose = () => {
        setIsExpiredModalOpen(false);
        navigate("/planPackage");
      };
      
     // clear field
    const resetInputHistory = () => {
        setSelectedToDate("");
        setSelectedFromDate("");
        setSelectedEmployeeOptions([]);
        setTeamIndu([]);
        setGetLeadStatus([]);
    };

    return (
        <>

             {remainingDays === 0 && isExpiredModalOpen && (
                    <SubExpired
                        onClose={handleClose}
                        profileData={profileData?.selectedPlanDetails?.planName}
                        remainingDays={remainingDays}
                    />
             )}
            <div>
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <BreadCrumb title="Add Lead" pageTitle="Add Lead" />
                        </div>

                        <div className="row">
                            <Card>
                                <div className="sn-number-file--filter mb-2 mt-3 col-md-12 col-sm-12 col-xs-12">
                                    <div className="">

                                        <Link to="/add-Lead" className="btn btn-danger">
                                            <i className="ri-add-fill me-1 align-bottom"></i>Add Lead
                                        </Link>
                                    </div>
                                    {/* <div className="">
                                        <div className="">
                                            <Link to="/Bulk-Operation" className="btn btn-danger">
                                                <i className="ri-add-fill me-1 align-bottom"></i>Bulk Import
                                            </Link>
                                        </div>
                                    </div> */}
                                </div>

                                <Row>
                                    <Col lg={12}>
                                        <div className="border-bottom pb-2">
                                            <Row className="sn">
                                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xs-12">
                                                    <DatePicker
                                                        labelContent="From Date"
                                                        getDate={selectedFromDate}
                                                        options={{
                                                            disable: [
                                                                {
                                                                    from: new Date(),
                                                                },
                                                            ],
                                                            dateFormat: "d M, Y",
                                                            maxDate: new Date(
                                                                new Date().setDate(new Date().getDate())
                                                            ),
                                                        }}
                                                        onChange={handleFromDateChange}
                                                    />
                                                </div>

                                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xs-12">

                                                    <DatePicker
                                                        labelContent="To Date"
                                                        getDate={selectedToDate}
                                                        options={{
                                                            disable: [
                                                                {
                                                                    from: new Date(),
                                                                },
                                                            ],
                                                            dateFormat: "d M, Y",
                                                            maxDate: new Date(
                                                                new Date().setDate(new Date().getDate())
                                                            ),
                                                        }}

                                                        onChange={handleToDateChange}
                                                    />
                                                </div>

                                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xs-12">
                                                    <div className="mb-3">
                                                        <TeamSelect
                                                            setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                                                            teamIndu={teamIndu}
                                                            setTeamIndu={setTeamIndu}
                                                            labelContent="Select Team"
                                                        />
                                                    </div>
                                                </div>


                                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xs-12">
                                                    <div className="mb-3">
                                                        <EmployeeSelect
                                                            setEmployeeDefaultWithoutTeam={setEmployeeDefaultWithoutTeam}
                                                            EmployeeDefaultWithoutTeam={EmployeeDefaultWithoutTeam}
                                                            error={error}
                                                            setError={setError}
                                                            EmployeeDefault={teamIndu.length === 0 ? EmployeeDefaultWithoutTeam : EmployeeData}
                                                            setEmployeeDefault={setEmployeeData}
                                                            teamIndu={teamIndu}
                                                            selectedEmployeeOptions={selectedEmployeeOptions}
                                                            setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                                                            setSelectedEmployeeOptions2={setSelectedEmployeeOptions2}
                                                            labelContent="Select Employee"
                                                        />
                                                    </div>
                                                </div>


                                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xs-12">
                                                    <div className="mb-3">
                                                        <CommonLabel htmlFor="leadstatus">
                                                            Select Lead Status
                                                        </CommonLabel>

                                                        <MultiSelect
                                                            options={statusOptions}
                                                            value={getLeadStatus}
                                                            onChange={handleStatusChange}
                                                            labelledBy={"Select"}
                                                            isCreatable={true}
                                                            overrideStrings={{ selectSomeItems: "Select Leads" }}
                                                            hasSelectAll={true}
                                                            className="classgroup"
                                                        />
                                                        {statusError && (
                                                            <small
                                                                className="sales-ninja-select-maltipale-lable"
                                                                style={{
                                                                    color: "red",
                                                                    position: "absolute",
                                                                    bottom: "2px",
                                                                    left: "22px",
                                                                }}
                                                            >
                                                                <span></span>
                                                                {statusError}
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>


                                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xs-12">
                                                    <FormGroup>
                                                        <Label for="exampleSelect"></Label>
                                                        <div id="exampleSelect" className="sn-call-apply-btn-reset mt-2">
                                                            <Button
                                                                id="exampleSelect"
                                                                type="submit"
                                                                color="danger"
                                                                className=""
                                                                onClick={handleApplySubmit}
                                                            // disabled={isLoading}
                                                            >
                                                                Apply
                                                            </Button>
                                                            <Button
                                                                className=""
                                                                style={{
                                                                    marginLeft: "10px",
                                                                }}
                                                                id="exampleSelect"
                                                                outline
                                                                color="danger"
                                                                onClick={resetInputHistory}
                                                            >
                                                                Reset
                                                            </Button>
                                                        </div>
                                                    </FormGroup>
                                                </div>

                                            </Row>
                                        </div>
                                    </Col>
                                </Row>


                                {getListData && getListData.length > 0 && <FilterDropdown
                                    checkOpen={checkOpen}
                                    handleAllEditLeadClick={handleAllEditLeadClick}
                                    onClickAllLeadDelete={onClickAllLeadDelete}
                                    setIsDropdownOpen={setIsDropdownOpen}
                                    isDropdownOpen={isDropdownOpen}
                                    setActiveColumns={setActiveColumns}
                                    allColumns={columns}
                                    selectedOptions={selectedOptions}
                                    setSelectedOptions={setSelectedOptions}
                                    searchTerm={searchTerm}
                                    handleSearchChange={handleSearchChange} />}

                                <DeleteModal
                                    show={deleteModal}
                                    onDeleteClick={() => handleDeleteLeadData()}
                                    onCloseClick={() => setDeleteModal(false)}
                                />

                                <CommanSelectModal
                                    allStatusError={allStatusError}
                                    toggle={toggle}
                                    getFieldProps={getFieldProps}
                                    handleSubmit={handleSubmit}
                                    handleAllStatusChange={handleAllStatusChange}
                                    handleAssignedChange={handleAssignedChange}
                                    headerLabel={"Update Lead"}
                                    // initialData={allLeadRemoveId}
                                    className={"btn-danger"}
                                    buttonText='Submit'
                                    isModalOpen={isModalOpen}
                                    setIsModalOpen={setIsModalOpen}

                                />

                                <CommanDataTable
                                    onSelectedRowsChange={handleSelectedRowsChange()}
                                    column={activeColumns}
                                    tableData={getListData}
                                    selectableRows
                                    searchText={query}
                                    setCurrentPage={setCurrentPage}
                                    perPage={perPage}
                                    totalRows={totalRows}
                                    handleSearch={handleSearch}
                                    handlePerRowsChange={handlePerRowsChange}
                                    currentPage={currentPage}
                                    isLoading={isLoading}
                                    handlePageChange={handlePageChange}
                                    inputClass={
                                        (getListData && getListData.length > 0) ||
                                            query
                                            ? "d-block"
                                            : "d-none"
                                    }
                                    noData='There are no records to display'
                                    className=""
                                />
                            </Card>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default LeadManagment;